/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_HourlyInputs */

const en_admin_external_booking_edit_hourly = /** @type {(inputs: Admin_External_Booking_Edit_HourlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hourly`)
};

const de_admin_external_booking_edit_hourly = /** @type {(inputs: Admin_External_Booking_Edit_HourlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stündlich`)
};

const es_admin_external_booking_edit_hourly = /** @type {(inputs: Admin_External_Booking_Edit_HourlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por hora`)
};

const fr_admin_external_booking_edit_hourly = /** @type {(inputs: Admin_External_Booking_Edit_HourlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horaire`)
};

const nl_admin_external_booking_edit_hourly = /** @type {(inputs: Admin_External_Booking_Edit_HourlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per uur`)
};

/** @type {(inputs: Admin_External_Booking_Edit_HourlyInputs) => LocalizedString} */
const it_admin_external_booking_edit_hourly = en_admin_external_booking_edit_hourly;

/** @type {(inputs: Admin_External_Booking_Edit_HourlyInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_hourly = en_admin_external_booking_edit_hourly;

/** @type {(inputs: Admin_External_Booking_Edit_HourlyInputs) => LocalizedString} */
const pl_admin_external_booking_edit_hourly = en_admin_external_booking_edit_hourly;

/** @type {(inputs: Admin_External_Booking_Edit_HourlyInputs) => LocalizedString} */
const hu_admin_external_booking_edit_hourly = en_admin_external_booking_edit_hourly;

/** @type {(inputs: Admin_External_Booking_Edit_HourlyInputs) => LocalizedString} */
const ro_admin_external_booking_edit_hourly = en_admin_external_booking_edit_hourly;

/**
* | output |
* | --- |
* | "Hourly" |
*
* @param {Admin_External_Booking_Edit_HourlyInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_hourly = /** @type {((inputs?: Admin_External_Booking_Edit_HourlyInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_HourlyInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_hourly(inputs)
	if (locale === "de") return de_admin_external_booking_edit_hourly(inputs)
	if (locale === "es") return es_admin_external_booking_edit_hourly(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_hourly(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_hourly(inputs)
	if (locale === "it") return it_admin_external_booking_edit_hourly(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_hourly(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_hourly(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_hourly(inputs)
	return ro_admin_external_booking_edit_hourly(inputs)
});
export { admin_external_booking_edit_hourly as "admin.external_booking_edit.hourly" }